import { inject } from '@angular/core';
import { ActivatedRouteSnapshot } from '@angular/router';

import { LegalPagesRouteService } from './legal-pages-route.service';


/**------------------------------------------------------
 * Functional Guards
 * These are new guards which got implemented with respect
 * to the angular latest version 14 and above version
 * to simplify the class based boilerplate.
 * https://angular.dev/api/router/DeprecatedGuard
 */

//** Activates the page path if the condition is passed */
export const LEGAL_PAGES_ROUTE_GUARD = (routeSnapshot: ActivatedRouteSnapshot): boolean => {
	return inject(LegalPagesRouteService).canActivateLegalPageRoute(routeSnapshot);
};
